import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams, useLocation } from 'react-router-dom';
import { Creators as GetCampusTabletsActions } from '../../../../../domain/useCases/reservation/getCampusTablets';
import { Creators as GetDatesLibraryActions } from '../../../../../domain/useCases/reservation/getDatesLibrary';
import { Creators as SubscribeResourceActions } from '../../../../../domain/useCases/reservation/subscribeResourceUseCase';
import ReservationRegisterView from './ReservationRegisterView';
import useTitle from '@/presentation/hooks/useTitle';
import useProfile from '@/presentation/hooks/useProfile';
import useExternalSettings from '../../../../hooks/useExternalSettings';

import XCheckpointManager from '../../../../../core/managers/xcheckpointManager';
import GoogleAnalytics from '@/presentation/hooks/useGoogleAnalytics';
import ModuleContainer from '@/presentation/components/Container';
import { SubsectionHeader } from '@/presentation/reusables/SectionHeader';
import Spinner from '@/presentation/components/Spinner';
import { useRole } from '@/presentation/hooks/useRole';

const ReservationRegisterController = () => {
  const dispatch = useDispatch();
  const params = useParams();
  const { isVisor } = useRole();
  const location = useLocation();
  const history = useHistory();
  if (!params) {
    history.push('/reserva');
  }

  const [dataCampus, setDataCampus] = useState<any[]>([]);
  const [restriction, setRestriction] = useState(false);
  const [dataLibraries, setDataLibraries] = useState<any[]>([]);
  const [dataDates, setDataDates] = useState<any[]>([]);
  const [dataHours, setDataHours] = useState<any[]>([]);
  const [dataDurations, setDataDurations] = useState<any[]>([]);
  const [openingHours, setOpeningHours] = useState<any>();

  const [selectCampus, setSelectCampus] = useState<any>();
  const [selectLibrary, setSelectLibrary] = useState<any>();
  const [selectDate, setSelectDate] = useState<any>();
  const [selectHour, setSelectHour] = useState<any>();
  const [selectDuration, setSelectDuration] = useState<any>();

  const [isCheck, setIsCheck] = useState<boolean>(false);
  const [isCancel, setIsCancel] = useState<boolean>(false);
  const [isComplete, setIsComplete] = useState<boolean>(false);
  const [isError, setIsError] = useState<boolean>(false);
  const [isSorry, setIsSorry] = useState<boolean>(false);
  const [isSorry2, setIsSorry2] = useState<boolean>(false);
  const [isValid, setIsValid] = useState<boolean>(false);

  const [loadResources, setLoadResources] = useState<boolean>(false);

  const resource = location.pathname.split('/')[2];

  const [resourceType] = useState({
    isTablet: resource === 'tablet',
    isComputer: resource === 'computadora',
    isRoom: resource === 'sala'
  });

  const { isLoading: isLoadingCampus, data: responseCampus } = useSelector(
    (state: any) => state.getCampusTablets
  );

  const { isLoading: isLoadingDates, data: responseDates } = useSelector(
    (state: any) => state.getDatesLibrary
  );

  const { isLoading: isProcessing, data: subscribeResourceTablet } =
    useSelector((state: any) => state.subscribeResource);

  const { academic } = useProfile();
  const { currentPeriod } = useExternalSettings();
  const isPeriodCurrent = useSelector(
    (state: any) =>
      state.getPeriods?.data?.some((period: any) => period.isCurrent) ?? false
  );
  const studentInPeriodCurrent = () =>
    isPeriodCurrent || Number(academic?.period?.id) === Number(currentPeriod);

  const handlerBackConfirm = () => {
    history.push('/servicios/recursos');
  };

  const handlerBack = () => {
    if (selectDate || selectHour || selectDuration || isCheck) {
      setIsCancel(true);
    } else {
      history.push('/servicios/recursos');
    }
  };

  const handlerRedirectToDetail = () => {
    const { idReservation } = subscribeResourceTablet;
    history.push(`/servicios/recursos/reserva/detalle?id=${idReservation}`);
  };

  const getDates = (idLibrary: any) => {
    let typeResource = 'T';
    if (resourceType.isComputer) typeResource = 'C';
    if (!loadResources) {
      dispatch(GetDatesLibraryActions.getDatesLibrary(idLibrary, typeResource));
      setLoadResources(true);
    }
  };

  const handlerData = (option: string, obj: any) => {
    if (option === 'campus') {
      const matchCampus = dataCampus.find((v: any) => v.id === obj.id);
      const matchLibrary = matchCampus?.libraries[0];
      if (matchLibrary) {
        setDataLibraries(matchCampus.libraries);
        setSelectCampus(obj);
        setSelectLibrary({ id: matchLibrary.id, name: matchLibrary.name });
        setSelectDate(undefined);
        setSelectHour(undefined);
        setSelectDuration(undefined);
        getDates(matchLibrary.id);
      }
    }

    if (option === 'library') {
      setSelectLibrary(obj);
      setSelectDate(undefined);
      setSelectHour(undefined);
      setSelectDuration(undefined);
      getDates(obj.id);
    }

    if (option === 'date') {
      const matchDate = dataDates.find((v: any) => v.id === obj.id);
      setSelectDate(obj);
      setOpeningHours({
        hourStart: matchDate.hourStart,
        hourEnd: matchDate.hourEnd
      });
      setSelectHour(undefined);
      setDataHours(matchDate?.hours);
    }

    if (option === 'hour') {
      const matchDate = dataDates.find((v: any) => v.id === selectDate.id);

      if (!matchDate) return;

      const [hourA, minA] = obj.hour.split(':').map(Number);
      const [hourB, minB] = matchDate.hourEnd.split(':').map(Number);

      const minHourA = hourA * 60 + minA;
      const minHourB = hourB * 60 + minB;
      const timeDifference = Math.abs(minHourA - minHourB) - 15;

      let selectedDurations: any[] = [];

      if (timeDifference < 60) {
        selectedDurations = matchDate.durations.slice(0, 1);
      } else if (timeDifference < 120) {
        selectedDurations = matchDate.durations.slice(0, 2);
      } else if (timeDifference < 180) {
        selectedDurations = matchDate.durations.slice(0, 3);
      } else {
        selectedDurations = matchDate.durations;
      }

      setSelectHour(obj);
      setDataDurations(selectedDurations);
    }

    if (option === 'duration') {
      setSelectDuration(obj);
    }
  };
  const handlerSubmit = () => {
    if (isVisor) {
      setRestriction(true);
      return;
    }
    let typeResource = 'T';
    if (resourceType.isComputer) typeResource = 'C';
    const hoursOffSet = new Date().getTimezoneOffset() / 60;
    XCheckpointManager.registerStart(`Reserva recursos registro`);
    dispatch(
      SubscribeResourceActions.subscribeResource(
        selectDuration.hour,
        selectHour.timestamp + hoursOffSet * 60 * 60 * 1000, // fix para servicio
        selectLibrary.id,
        typeResource
      )
    );
  };

  useEffect(() => {
    if (!studentInPeriodCurrent()) history.push('/servicios/recursos');
  }, []);

  useEffect(() => {
    if (responseCampus) {
      const { campus, campusStudent } = responseCampus;

      const initCampus = campus?.find((v: any) => v.id === campusStudent);

      const initLibrary =
        initCampus === undefined
          ? campus[0]?.libraries[0]
          : initCampus?.libraries[0];
      setDataCampus(campus);
      setDataLibraries(
        initCampus !== undefined ? initCampus?.libraries : campus[0].libraries
      );
      setSelectCampus({
        id: initCampus !== undefined ? initCampus?.id : campus[0].id,
        name: initCampus !== undefined ? initCampus?.name : campus[0].name
      });
      handlerData('library', {
        id: initLibrary?.id,
        name: initLibrary?.name
      });
    }
  }, [responseCampus]);

  useEffect(() => {
    if (responseDates) {
      setDataDates(responseDates);
    }
  }, [responseDates]);

  useEffect(() => {
    if (selectDate && selectHour && selectDuration && isCheck) {
      setIsValid(true);
    } else {
      setIsValid(false);
    }
  }, [selectDate, selectHour, selectDuration, isCheck]);

  useEffect(() => {
    if (subscribeResourceTablet) {
      const { idReservation, typeError } = subscribeResourceTablet;
      if (typeError === 0 && idReservation > 0) setIsComplete(true);
      if (typeError === 1) setIsSorry2(true); // tienes una reserva programada para este horario
      if (typeError === 2) setIsSorry(true); // lo sientimos no está disponible
      if (typeError === 4) setIsError(true); // error genérico
      XCheckpointManager.registerEnd(`Reserva recursos registro`);
    }
  }, [subscribeResourceTablet]);

  useEffect(() => {
    XCheckpointManager.registerStart(`Reserva ingreso`);
    GoogleAnalytics.writeLog(
      `portal-services-reservation${
        resourceType.isTablet ? 'Tablet' : 'Computer'
      }`,
      'services'
    );
    dispatch(GetCampusTabletsActions.getCampusTablets());
    return () => {
      dispatch(GetCampusTabletsActions.getCampusTabletsClear());
      dispatch(GetDatesLibraryActions.getDatesLibraryClear());
    };
  }, []);

  useEffect(() => {
    if (loadResources && !isLoadingCampus && !isLoadingDates) {
      setLoadResources(false);
    }
  }, [isLoadingCampus, isLoadingDates]);

  useEffect(() => {
    if (responseCampus && responseDates) {
      XCheckpointManager.registerEnd(`Reserva ingreso`);
    }
  }, [responseCampus, responseDates]);

  useTitle(resource);
  useTitle(`Reserva de ${resource}`);

  const getTitle = () => {
    if (resourceType.isTablet) {
      return 'Reserva de tablet';
    }

    if (resourceType.isComputer) {
      return 'Reserva de computadora';
    }

    return '';
  };

  const title = getTitle();

  let content;

  if (isLoadingCampus) {
    content = <Spinner />;
  } else if (responseCampus) {
    content = (
      <ReservationRegisterView
        dataCampus={dataCampus}
        dataDates={dataDates}
        dataDurations={dataDurations}
        dataHours={dataHours}
        dataLibraries={dataLibraries}
        handlerBackConfirm={handlerBackConfirm}
        handlerData={handlerData}
        handlerSubmit={handlerSubmit}
        isCancel={isCancel}
        isCheck={isCheck}
        isComplete={isComplete}
        isError={isError}
        isLoadingDates={isLoadingDates}
        isProcessing={isProcessing}
        isSorry={isSorry}
        isSorry2={isSorry2}
        isValid={isValid}
        selectCampus={selectCampus}
        selectDate={selectDate}
        selectDuration={selectDuration}
        selectHour={selectHour}
        selectLibrary={selectLibrary}
        setIsCancel={setIsCancel}
        setIsCheck={setIsCheck}
        setIsError={setIsError}
        setIsSorry={setIsSorry}
        setIsSorry2={setIsSorry2}
        handlerRedirectToDetail={handlerRedirectToDetail}
        resourceType={resourceType}
        openingHours={openingHours}
        restriction={restriction}
        setRestriction={setRestriction}
      />
    );
  } else {
    content = null;
  }

  return (
    <ModuleContainer containerType="subsection">
      <SubsectionHeader title={title} onClick={() => handlerBack()} />
      {content}
    </ModuleContainer>
  );
};

export default ReservationRegisterController;
